/* TAC conflict pages: branch tabs and the unit finder in "Who was there".
   The finder uses the same index as the header search (assets/tac-unit-search.js). */
(function (w, d) {
  'use strict';
  if (w.TACConflict) return;
  w.TACConflict = { version: '1.0.0' };

  function initUnits(el) {
    var tabs = [].slice.call(el.querySelectorAll('[data-tc-tab]'));
    var panels = [].slice.call(el.querySelectorAll('[data-tc-panel]'));
    function show(key) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-tc-tab') === key ? 'true' : 'false'); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-tc-panel') !== key; });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-tc-tab')); }); });
    if (tabs.length) show(tabs[0].getAttribute('data-tc-tab'));

    var form = el.querySelector('[data-tc-find]');
    var input = el.querySelector('[data-tc-find-input]');
    var list = el.querySelector('[data-tc-find-list]');
    if (!form || !input || !list) return [];
    var requestUrl = el.getAttribute('data-request-url') || '/pages/custom-designs';
    var results = [], active = -1, timer;

    function close() { list.hidden = true; list.innerHTML = ''; results = []; active = -1; }
    function render(items) {
      list.innerHTML = '';
      results = items; active = -1;
      if (!items.length) {
        var li = d.createElement('li');
        li.className = 'tc-find__empty';
        var s = d.createElement('span'); s.textContent = 'Not built yet. ';
        var a = d.createElement('a'); a.href = requestUrl; a.textContent = 'Request it';
        li.appendChild(s); li.appendChild(a); list.appendChild(li);
      } else {
        items.forEach(function (it, i) {
          var li = d.createElement('li');
          var a = d.createElement('a');
          a.className = 'tc-find__opt'; a.href = it.url; a.setAttribute('data-i', i);
          var b = d.createElement('b'); b.textContent = it.title; a.appendChild(b);
          var sm = d.createElement('small'); sm.textContent = (it.branch || 'unit').toUpperCase(); a.appendChild(sm);
          li.appendChild(a); list.appendChild(li);
        });
      }
      list.hidden = false;
    }
    function search() {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      var U = w.TACUnitSearch;
      if (!U || !U.ready) return;
      U.ready().then(function (ok) {
        if (!ok || input.value.trim() !== q) return;
        var hits = U.match(q, 6);
        render(hits);
        if (U.track) U.track('conflict', q, hits);
      });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(search, 160); });
    input.addEventListener('keydown', function (e) {
      if (list.hidden) return;
      var opts = list.querySelectorAll('.tc-find__opt');
      if (e.key === 'ArrowDown') { e.preventDefault(); active = Math.min(active + 1, opts.length - 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); active = Math.max(active - 1, 0); }
      else if (e.key === 'Escape') { close(); return; }
      else return;
      [].forEach.call(opts, function (o, k) { o.classList.toggle('is-active', k === active); });
    });
    form.addEventListener('submit', function (e) {
      /* Enter goes to the unit collection, never to a product grid. */
      if (results.length) { e.preventDefault(); w.location.href = results[active >= 0 ? active : 0].url; }
    });
    function onDoc(e) { if (!el.contains(e.target)) close(); }
    d.addEventListener('click', onDoc);
    return [function () { d.removeEventListener('click', onDoc); }];
  }

  function mount(el) {
    if (el.getAttribute('data-tc-ready')) return [];
    el.setAttribute('data-tc-ready', '1');
    return initUnits(el);
  }
  function boot() {
    [].slice.call(d.querySelectorAll('[data-section-type="tac-conflict-units"]')).forEach(mount);
  }
  if (w.TAC && typeof w.TAC.registerSection === 'function') {
    w.TAC.registerSection('tac-conflict-units', { init: function (el) { return mount(el); } });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', boot);
})(window, document);
